import webAppCommon from '@it-enterprise/web-app-common'
import layouts from '@/app-model/layout'
import mainmenu from '@it-enterprise/web-app-common/src/mainmenu'

function InitWebAppCommon(Vue, options) {
  const { formioOptions, dependencies, gqTools, eds } = options
  Vue.use(webAppCommon, {
    layouts,
    formio: {
      formioOptions,
      dependencies,
      gqTools
    },
    eds: eds
  })
  Vue.use(mainmenu, gqTools, dependencies)
}

export default InitWebAppCommon